import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import { alpha } from '@mui/material/styles';
import Filler from 'components/shared/Layout/Filler';
import Rows from 'components/shared/Layout/Rows';
import { userSelector } from 'features/user/selectors';
import { UserActionDrawerListOptions } from 'layout/components/drawer/UserActionDrawerListOptions';
import { useLayoutContext } from 'layout/context';
import { useAppSelector } from 'store/hooks';

function DrawerList() {
  const theme = useTheme();
  const user = useAppSelector(userSelector);

  const { drawerOptions } = useLayoutContext();

  return (
    (user && (
      <Rows
        sx={{
          flex: 1,
          p: 0,
          py: 1,
          [theme.breakpoints.down('md')]: {
            px: 1.5,
          },
        }}
      >
        {drawerOptions}
        <Filler />
        <Divider
          sx={{
            my: 1,
            borderColor: (theme) => alpha(theme.palette.common.white, 0.12),
          }}
        />
        <UserActionDrawerListOptions />
      </Rows>
    )) ??
    null
  );
}

export default DrawerList;
